export var streamType = '@@WATCHSUGGESTIONS';
export var streamId = 'WATCH_SUGGESTIONS_STREAM';
//# sourceMappingURL=constants.js.map